import React from 'react';
import WarningRounded from '@mui/icons-material/WarningRounded';
import { getProjectDateRange } from '#helper';

export function renderDate(p, account, isMobile) {
  const desktop = {
    color: '#667',
    width: '180px',
    marginLeft: 'auto',
    textAlign: 'right'
  };

  const mobile = {
    color: '#667',
    width: '100%',
    margin: 0
  };

  return (
    <span
      style={isMobile ? mobile : desktop}
    >
      {
        p.expirationDate && new Date(p.expirationDate) < new Date() ?
          <WarningRounded
            style={{
              color: '#FACE31',
              verticalAlign: 'bottom',
              marginRight: 5
            }}
          /> :
          null
      }
      {getProjectDateRange(p, account?.measurementSystem)}
    </span>
  );
}
